import { createTrackStandaloneEventHook } from './useTrackStandaloneEvent';
export const useTrackPageViewed = createTrackStandaloneEventHook('Page Viewed');